/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { PercentualRecebimentoRendaService } from '@services';
import { Tooltip, Table, LoadingIndicator, Button } from '@components';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const service = new PercentualRecebimentoRendaService();

export const HistoricoRecebimentoRendaPage = () => {
  const { matricula, plano } = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [historico, setHistorico] = useState([]);

  const getHistoricoIntencaoTroca = useCallback(async () => {
    setLoading(true);
    const historicoRecebimento =
      await service.getHistoricoIntencaoMudancaRecebimentoParticipante(
        matricula,
        plano
      );
    setHistorico(historicoRecebimento);
    setLoading(false);
  }, [matricula, plano]);

  useEffect(() => {
    getHistoricoIntencaoTroca();
  }, [getHistoricoIntencaoTroca]);

  return !loading ? (
    <>
      <Helmet>
        <title>
          Histórico de Intenção de Percentual de Troca de Recebimento Mensal
        </title>
      </Helmet>
      <div className="card">
        <div className="card-body">
          <span className="fw-bold ts-10 mb-32 mb-md-5">
            Histórico de Intenção de Percentual de Troca de Recebimento Mensal
            <Tooltip title="Veja o Histórico de Intenção de Percentual de Troca de Recebimento Mensal">
              ?
            </Tooltip>
          </span>
          {historico && (
            <Table
              className=" mb-4 mt-32"
              odd
              columns={[
                'Data Solicitação',
                'Percentual Atual',
                'Percentual Solicitado',
                'Data Hora Registro',
                'Data Hora Efetivação',
                'Autor Efetivação',
              ]}
            >
              {historico.map((linha) => {
                return (
                  <tr key={linha.DataSolicitacao}>
                    <td>{linha.DataSolicitacao}</td>
                    <td>{`${linha.PercentualAtual} %`}</td>
                    <td>{`${linha.PercentualSolicitado} %`}</td>
                    <td>{linha.DataHoraRegistro}</td>
                    <td>{linha.DataHoraEfetivacao}</td>
                    <td>{linha.AutorEfetivacao}</td>
                  </tr>
                );
              })}
            </Table>
          )}
        </div>
      </div>
    </>
  ) : (
    <LoadingIndicator />
  );
};
